<script>
  import { onMount } from "svelte";
  import TypeIt from "typeit";
  import ContactForm from "./ContactForm.svelte";

  const strings = [
    "Portuguese Geek.",
    "Software Engineering and Product Management.",
    "Technology Enthusiast and Tinkerer.",
  ];

  let contactOpen = $state(false);
  let typeitEl = $state(null);
  let reduceMotion = $state(false);

  onMount(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    reduceMotion = mq.matches;
    const onChange = (event) => (reduceMotion = event.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  });

  $effect(() => {
    if (reduceMotion) return;
    if (!typeitEl) return;

    const instance = new TypeIt(typeitEl, {
      strings,
      speed: 50,
      lifeLike: true,
      nextStringDelay: [2500, 0],
      breakLines: false,
      loop: true,
      loopDelay: 4000,
    }).go();

    return () => instance.destroy();
  });
</script>

<main class="container">
  <h1 class="name">
    <span class="bold">MANUEL</span>&nbsp;<span class="light">SARAIVA</span>
  </h1>

  <p class="sr-only">
    Portuguese geek. Software engineering and product management. Technology
    enthusiast and tinkerer.
  </p>
  {#if reduceMotion}
    <p class="tagline">{strings[1]}</p>
  {:else}
    <p bind:this={typeitEl} class="tagline" aria-hidden="true"></p>
  {/if}

  <div class="icons">
    <button
      class="icon-btn"
      onclick={() => (contactOpen = true)}
      aria-label="Contact me"
    >
      <svg viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"
        ><path
          d="M424 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zm-14.18 92.63l-144 112a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l134.18-104.36a16 16 0 0119.64 25.26z"
        /></svg
      >
    </button>
    <a
      class="icon-btn"
      href="https://www.linkedin.com/in/mnlsrv/"
      target="_blank"
      rel="noreferrer"
      aria-label="LinkedIn"
    >
      <svg viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"
        ><path
          d="M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zm-273.3 373.43h-64.18V205.88h64.18zM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43 0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44-17.74 0-28.24 12-32.91 23.69-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44 42.13 0 74 27.77 74 87.64z"
        /></svg
      >
    </a>
    <a
      class="icon-btn"
      href="https://x.com/mnlsrv"
      target="_blank"
      rel="noreferrer"
      aria-label="X (Twitter)"
    >
      <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
        ><path
          d="M9.333 6.929L14.546 1H13.31L8.783 6.147 5.169 1H1l5.466 7.783L1 15h1.235l4.779-5.436L10.83 15H15L9.333 6.929zM7.641 8.852l-.554-.776L2.68 1.911h1.898l3.557 4.977.552.776 4.623 6.47h-1.897L7.641 8.851z"
        /></svg
      >
    </a>
    <a
      class="icon-btn"
      href="https://github.com/mnlsrv"
      target="_blank"
      rel="noreferrer"
      aria-label="GitHub"
    >
      <svg viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"
        ><path
          d="M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9a17.56 17.56 0 003.8.4c8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1a102.4 102.4 0 01-22.6 2.7c-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1a63 63 0 0025.6-6c2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8a18.64 18.64 0 015-.5c8.1 0 26.4 3.1 56.6 24.1a208.21 208.21 0 01112.2 0c30.2-21 48.5-24.1 56.6-24.1a18.64 18.64 0 015 .5c12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5a19.35 19.35 0 004-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z"
        /></svg
      >
    </a>
  </div>
</main>

{#if contactOpen}
  <ContactForm onclose={() => (contactOpen = false)} />
{/if}

<footer class="footer">
  <a href="/privacy">Privacy</a>
</footer>

<style>
  .container {
    width: 100%;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .name {
    width: 100%;
    text-align: center;
    margin-top: auto;
    font-size: 5rem;
    color: white;
  }

  @media only screen and (max-width: 500px) {
    .name {
      font-size: 3rem;
    }
  }

  .bold {
    font-weight: 600;
  }

  .light {
    font-weight: 300;
  }

  .tagline {
    font-size: 1.5rem;
    color: #a5adbc;
    width: 100%;
    height: 4rem;
    padding: 1rem;
    text-align: center;
  }

  /* padding-bottom biases the whole block optically above center */
  .icons {
    display: flex;
    gap: 2rem;
    margin-top: 3rem;
    margin-bottom: auto;
    padding-bottom: 10rem;
  }

  .icon-btn {
    background: none;
    border: none;
    padding: 0;
    display: inline-flex;
    color: #a5adbc;
    cursor: pointer;
  }

  .icon-btn svg {
    width: 3.2rem;
    height: 3.2rem;
  }

  .icon-btn:hover {
    color: white;
  }

  .icon-btn:focus-visible {
    color: white;
    outline: 2px solid white;
    outline-offset: 4px;
    border-radius: 4px;
  }

  .footer {
    position: fixed;
    bottom: 1.6rem;
    width: 100%;
    text-align: center;
    font-size: 1.2rem;
  }

  .footer a {
    color: #a5adbc;
    text-decoration: none;
  }

  .footer a:hover,
  .footer a:focus-visible {
    color: white;
    text-decoration: underline;
  }
</style>
